/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { durations, durationStep } from './utils/durations';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { exitingDurations } from './utils/exiting-durations';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { Durations } from './utils/durations';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { easeIn, easeInOut, easeOut, linear } from './utils/curves';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { isReducedMotion } from './utils/is-reduced-motion';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { useIsReducedMotion } from './utils/use-is-reduced-motion';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { prefersReducedMotion } from './utils/accessibility';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { reduceMotionAsPerUserPreference } from './utils/reduce-motion-as-per-user-preference';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as FadeIn } from './entering/fade-in';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { FadeKeyframesMotionProps } from './entering/fade-in';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as AnimateIn } from './entering/animate-in';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { AnimateKeyframesMotionProps } from './entering/animate-in';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as StaggeredEntrance } from './entering/staggered-entrance';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { StaggeredEntranceProps } from './entering/staggered-entrance';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { ResizingHeight } from './resizing/height';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { useResizingHeight } from './resizing/use-resizing-height';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as ExitingPersistence } from './entering/exiting-persistence';
export { useExitingPersistence } from './entering/use-exiting-persistence';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { ExitingPersistenceProps } from './entering/exiting-persistence';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as ZoomIn } from './entering/zoom-in';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as SlideIn } from './entering/slide-in';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as ShrinkOut } from './entering/shrink-out';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { ShrinkOutProps } from './entering/shrink-out';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { Transition, Direction } from './entering/types';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as Motion, type MotionRef, type MotionProps } from './entering/motion';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { Reanimate } from './entering/reanimate';
